export default "__VITE_ASSET__DU1tvdVW__"